module.exports = __webpack_public_path__ + "static/media/hand-point-up.a3b067ae.svg";